<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER QISMI -->
      <div class="header-row">
        <h2 class="page-title">Savdolar Ro'yxati</h2>
        <div class="header-actions">
          <input type="date" v-model="filterDate1" class="date-input" @change="fetchSales" />
          <input type="date" v-model="filterDate2" class="date-input" @change="fetchSales" />
          <select v-model="filterMasterId" class="master-select" @change="fetchSales">
            <option :value="null">Barcha ustalar</option>
            <option v-for="m in masters" :key="m.id" :value="m.id">{{ m.name }}</option>
          </select>
          <button class="add-btn" @click="$router.push('/chiqim/pos')">
            <b-icon icon="plus-circle-fill" class="mr-1"></b-icon> Yangi Savdo (POS)
          </button>
          <Top />
        </div>
      </div>

      <!-- JADVAL QISMI -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width:55px">№</th>
                <th>SANA</th>
                <th>MIJOZ</th>
                <th>USTA</th>
                <th>PAKET</th>
                <th>MAHSULOT</th>
                <th>XIZMAT</th>
                <th>JAMI</th>
                <th>TO'LANDI</th>
                <th>QARZ</th>
                <th>MUDDAT</th>
                <th style="width:130px; text-align:center">AMAL</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in sales" :key="item.id" class="clickable-row" @click="openDetailModal(item)">
                <td><span class="id-badge">{{ item.id }}</span></td>

                <td class="text-dark font-bold">{{ formatDate(item.created_at) }}</td>

                <td>
                  <div class="font-bold text-dark">{{ item.kontragent ? item.kontragent.name : '-' }}</div>
                  <div class="text-muted small">{{ item.kontragent ? item.kontragent.phone_number : '' }}</div>
                </td>

                <td>
                  <span v-if="item.master">{{ item.master.name }}</span>
                  <span v-else class="text-muted small">-</span>
                </td>

                <td>
                  <span v-if="item.repair_package" class="tag blue-tag">{{ item.repair_package.name }}</span>
                  <span v-else class="text-muted small">-</span>
                </td>

                <td class="price">{{ formatMoney(item.product_summa) }}</td>

                <td class="price">
                  {{ formatMoney(Number(item.summa || 0) - Number(item.product_summa || 0)) }}
                </td>

                <td class="price blue">{{ formatMoney(item.summa) }}</td>

                <td class="price green" :title="paidBreakdown(item)">
                  {{ formatMoney(getPaid(item)) }}
                  <b-icon v-if="paidBreakdown(item)" icon="info-circle" class="paid-info-ico"></b-icon>
                </td>

                <td>
                  <span :class="getDebtClass(item)">{{ formatMoney(getDebt(item)) }}</span>
                </td>

                <td>
                  <span v-if="formatDueDate(item)" :class="['due-badge', isOverdue(item) ? 'overdue' : '']">
                    <b-icon icon="calendar-event"></b-icon> {{ formatDueDate(item) }}
                  </span>
                  <span v-else class="text-muted small">—</span>
                </td>

                <td>
                  <div class="actions">
                    <button v-if="getDebt(item) > 0" class="icon-btn pay" @click.stop="openPayModal(item)" title="To'lov qilish">
                      <b-icon icon="cash-stack"></b-icon>
                    </button>
                    <button class="icon-btn refund-btn" @click.stop="openRefundModal(item)" title="Qaytarish">
                      <b-icon icon="arrow-return-left"></b-icon>
                    </button>
                    <button class="icon-btn print" @click.stop="printSaleReceipt(item)" title="Chop etish">
                      <b-icon icon="printer"></b-icon>
                    </button>
                    <button class="icon-btn del" @click.stop="openDeleteModal(item)" title="O'chirish">
                      <b-icon icon="trash"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>

              <tr v-if="!loading && sales.length === 0">
                <td colspan="12" class="empty-row">
                  <div class="py-5 text-center">
                    <p>Ma'lumot topilmadi</p>
                  </div>
                </td>
              </tr>

              <tr v-if="loading">
                <td colspan="12" class="text-center py-5">
                  <b-spinner variant="primary"></b-spinner>
                </td>
              </tr>
            </tbody>

            <!-- JAMI QATORI -->
            <tfoot v-if="sales.length > 0">
              <tr class="total-row">
                <td colspan="5" class="text-right font-bold">JAMI:</td>
                <td class="price font-bold">{{ formatMoney(totalProductSumma) }}</td>
                <td class="price font-bold">{{ formatMoney(totalServiceSumma) }}</td>
                <td class="price blue font-bold">{{ formatMoney(totalSumma) }}</td>
                <td class="price green font-bold">{{ formatMoney(totalPaid) }}</td>
                <td class="price red font-bold">{{ formatMoney(totalDebt) }}</td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

    </div>

    <!-- DETAIL MODALI -->
    <div v-if="showDetailModal && detailItem" class="modal-overlay" @click.self="closeDetailModal">
      <div class="detail-modal animate-pop">
        <div class="detail-header">
          <h3>Savdo #{{ detailItem.id }}</h3>
          <button class="close-btn" @click="closeDetailModal">&times;</button>
        </div>

        <div class="detail-info">
          <div class="info-row">
            <span class="info-label">Sana:</span>
            <span>{{ formatDate(detailItem.created_at) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Mijoz:</span>
            <span>{{ detailItem.kontragent ? detailItem.kontragent.name : '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Usta:</span>
            <span>{{ detailItem.master ? detailItem.master.name : '-' }}</span>
          </div>
        </div>

        <!-- XIZMATLAR -->
        <div v-if="detailItem.packages && detailItem.packages.length > 0" class="detail-section">
          <h4 class="section-title purple">
            Xizmatlar
            <span class="sale-type-chip" :class="detailSaleType">{{ detailSaleType === 'optom' ? 'Optom' : 'Chakana' }}</span>
          </h4>
          <table class="detail-table">
            <thead>
              <tr>
                <th>№</th>
                <th>Nomi</th>
                <th>Ish haqi</th>
                <th>Peredelka</th>
                <th>Jami</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(pkg, idx) in detailItem.packages" :key="pkg.id">
                <td>{{ idx + 1 }}</td>
                <td>{{ pkg.name || '-' }}</td>
                <td class="text-right">{{ formatMoney(packageLabor(pkg)) }}</td>
                <td class="text-right">{{ formatMoney(packageRedo(pkg)) }}</td>
                <td class="text-right font-bold">{{ formatMoney(packageLabor(pkg) + packageRedo(pkg)) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="total-row">
                <td colspan="4" class="text-right font-bold">JAMI:</td>
                <td class="text-right font-bold purple">{{ formatMoney(servicesTotal) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- Bitta paket (packages yo'q, lekin repair_package bor) -->
        <div v-else-if="detailItem.repair_package" class="detail-section">
          <h4 class="section-title purple">
            Xizmat
            <span class="sale-type-chip" :class="detailSaleType">{{ detailSaleType === 'optom' ? 'Optom' : 'Chakana' }}</span>
          </h4>
          <table class="detail-table">
            <thead>
              <tr>
                <th>Nomi</th>
                <th>Ish haqi</th>
                <th>Peredelka</th>
                <th>Jami</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ detailItem.repair_package.name }}</td>
                <td class="text-right">{{ formatMoney(packageLabor(detailItem)) }}</td>
                <td class="text-right">{{ formatMoney(packageRedo(detailItem)) }}</td>
                <td class="text-right font-bold">{{ formatMoney(packageLabor(detailItem) + packageRedo(detailItem)) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="total-row">
                <td colspan="3" class="text-right font-bold">JAMI:</td>
                <td class="text-right font-bold purple">{{ formatMoney(packageLabor(detailItem) + packageRedo(detailItem)) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- MAHSULOTLAR -->
        <div v-if="detailItem.items && detailItem.items.length > 0" class="detail-section">
          <h4 class="section-title blue">Mahsulotlar</h4>
          <table class="detail-table">
            <thead>
              <tr>
                <th>№</th>
                <th>Nomi</th>
                <th>Soni</th>
                <th>Narxi</th>
                <th>Summasi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(itm, idx) in detailItem.items" :key="itm.id">
                <td>{{ idx + 1 }}</td>
                <td>{{ itm.product ? (itm.product.extra_name || itm.product.name) : '-' }}</td>
                <td class="text-right">{{ itm.count }}</td>
                <td class="text-right">{{ formatMoney(itm.price) }}</td>
                <td class="text-right font-bold">{{ formatMoney(itm.summa) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="total-row">
                <td colspan="4" class="text-right font-bold">JAMI:</td>
                <td class="text-right font-bold blue">{{ formatMoney(detailItem.product_summa) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div v-if="(!detailItem.items || detailItem.items.length === 0) && !detailItem.repair_package && (!detailItem.packages || detailItem.packages.length === 0)" class="empty-detail">
          Ma'lumot topilmadi
        </div>

        <!-- UMUMIY SUMMA + TO'LOV TAFSILOTI -->
        <div class="detail-footer">
          <div class="footer-row">
            <span>Xizmat:</span>
            <span class="purple font-bold">{{ formatMoney(Number(detailItem.summa || 0) - Number(detailItem.product_summa || 0) + Number(detailItem.skidka_summa || 0)) }}</span>
          </div>
          <div class="footer-row">
            <span>Mahsulot:</span>
            <span class="font-bold">{{ formatMoney(detailItem.product_summa) }}</span>
          </div>
          <div v-if="Number(detailItem.skidka_summa || 0) > 0" class="footer-row">
            <span>Chegirma:</span>
            <span class="font-bold" style="color:#ea580c">- {{ formatMoney(detailItem.skidka_summa) }}</span>
          </div>
          <div class="footer-row total">
            <span>JAMI:</span>
            <span class="blue font-bold">{{ formatMoney(detailItem.summa) }}</span>
          </div>

          <!-- To'lov turlari bo'yicha breakdown -->
          <div class="pay-breakdown">
            <div class="pay-breakdown-title">To'lov tafsiloti:</div>
            <template v-if="Array.isArray(detailItem.pay_table) && detailItem.pay_table.length > 0">
              <div v-for="(r, i) in detailItem.pay_table" :key="'pt-' + i" class="footer-row pay-line">
                <span>
                  {{ (r.pay_type && r.pay_type.name) || ('Tur #' + r.pay_type_id) }}<span v-if="parseInt(r.pay_type_id) === 3"> ($)</span>:
                </span>
                <span class="font-bold">
                  <template v-if="parseInt(r.pay_type_id) === 3">
                    $ {{ formatMoney(r.summa) }}
                    <small class="text-muted">≈ {{ formatMoney(Number(r.summa) * (Number(detailItem.dollar_rate) || 1)) }}</small>
                  </template>
                  <template v-else>{{ formatMoney(r.summa) }}</template>
                </span>
              </div>
            </template>
            <template v-else>
              <div v-if="Number(detailItem.cash_summa || 0) > 0" class="footer-row pay-line">
                <span>Naqd:</span><span class="font-bold">{{ formatMoney(detailItem.cash_summa) }}</span>
              </div>
              <div v-if="Number(detailItem.plastic_summa || 0) > 0" class="footer-row pay-line">
                <span>Plastik:</span><span class="font-bold">{{ formatMoney(detailItem.plastic_summa) }}</span>
              </div>
              <div v-if="Number(detailItem.shot_summa || 0) > 0" class="footer-row pay-line">
                <span>Hisob:</span><span class="font-bold">{{ formatMoney(detailItem.shot_summa) }}</span>
              </div>
              <div v-if="Number(detailItem.dollar_summa || 0) > 0" class="footer-row pay-line">
                <span>Dollar:</span><span class="font-bold">$ {{ formatMoney(detailItem.dollar_summa) }}</span>
              </div>
            </template>
          </div>
          <div v-if="Number(detailItem.refund_money || 0) > 0" class="footer-row pay-line">
            <span>Qaytim:</span>
            <span class="font-bold">{{ formatMoney(detailItem.refund_money) }} so'm</span>
          </div>

          <div class="footer-row total" style="border-top: 1px dashed #cbd5e1; margin-top: 8px;">
            <span class="green">Jami to'landi:</span>
            <span class="green font-bold">{{ formatMoney(getPaid(detailItem)) }}</span>
          </div>
          <div v-if="getDebt(detailItem) > 0" class="footer-row total">
            <span class="red">Qarz qoldi:</span>
            <span class="red font-bold">{{ formatMoney(getDebt(detailItem)) }}</span>
          </div>
          <div v-if="formatDueDate(detailItem)" class="footer-row" style="margin-top: 6px;">
            <span>Qarz muddati:</span>
            <span :class="['due-badge', isOverdue(detailItem) ? 'overdue' : '']">
              <b-icon icon="calendar-event"></b-icon> {{ formatDueDate(detailItem) }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- O'CHIRISH MODALI -->
    <div v-if="showDeleteModal" class="modal-overlay" @click.self="closeDeleteModal">
      <div class="modal-box animate-pop">
        <div class="warning-icon">!</div>
        <h3>O'chirishni tasdiqlaysizmi?</h3>
        <p v-if="selectedItem" class="text-secondary mt-2">
          <b>#{{ selectedItem.id }}</b> savdo tizimdan o'chiriladi.
        </p>
        <div class="modal-btns">
          <button class="m-btn cancel" @click="closeDeleteModal">YO'Q</button>
          <button class="m-btn confirm" @click="deleteItem">HA, O'CHIRILSIN</button>
        </div>
      </div>
    </div>

    <!-- TO'LOV MODALI -->
    <div v-if="showPayModal && payItem" class="modal-overlay" @click.self="closePayModal">
      <div class="pay-modal animate-pop">
        <div class="detail-header">
          <h3>Qarz to'lash — Savdo #{{ payItem.id }}</h3>
          <button class="close-btn" @click="closePayModal">&times;</button>
        </div>

        <div class="pay-info">
          <div class="pay-info-row">
            <span class="info-label">Mijoz:</span>
            <span class="font-bold">{{ payItem.kontragent ? payItem.kontragent.name : '-' }}</span>
          </div>
          <div class="pay-info-row">
            <span class="info-label">Savdo summasi:</span>
            <span class="font-bold blue">{{ formatMoney(payItem.summa) }} UZS</span>
          </div>
          <div class="pay-info-row">
            <span class="info-label">To'langan:</span>
            <span class="font-bold green">{{ formatMoney(getPaid(payItem)) }} UZS</span>
          </div>
          <div class="pay-info-row">
            <span class="info-label">Qarz qoldiq:</span>
            <span class="font-bold red">{{ formatMoney(getDebt(payItem)) }} UZS</span>
          </div>
        </div>

        <div class="pay-form">
          <!-- BARCHA TO'LOV TURLARI (qo'shish/o'chirishsiz, ochiq) -->
          <div class="method-grid">
            <div v-for="pt in paytypes" :key="pt.id" class="pay-field">
              <label>{{ pt.name }} {{ isDollarType(pt.id) ? '($)' : "(so'm)" }}</label>
              <summa-input v-model="payAmounts[pt.id]" input-class="pay-input" placeholder="0" />
              <small v-if="isDollarType(pt.id) && payDollarSomEq > 0" class="conv-hint">
                ≈ {{ formatMoney(payDollarSomEq) }} so'm
              </small>
            </div>
          </div>

          <!-- DOLLAR KURSI (konvertatsiya) -->
          <div v-if="hasDollarType" class="pay-field">
            <label>Dollar kursi (1$ = ? so'm)</label>
            <summa-input v-model="payDollarRate" input-class="pay-input" placeholder="0" />
          </div>

          <div class="pay-field">
            <label>Izoh</label>
            <input type="text" v-model="payForm.comment" class="pay-input" placeholder="Izoh..." />
          </div>

          <div class="pay-total-row">
            <span>Jami to'lov:</span>
            <span class="font-bold blue">{{ formatMoney(payFormTotal) }} UZS</span>
          </div>
          <div class="pay-total-row">
            <span>To'lovdan keyin qoldiq:</span>
            <span class="font-bold" :class="payRemaining > 0 ? 'red' : 'green'">{{ formatMoney(payRemaining) }} UZS</span>
          </div>
        </div>

        <div class="pay-actions">
          <button class="m-btn cancel" @click="closePayModal">BEKOR</button>
          <button class="m-btn pay-confirm" @click="submitPayment" :disabled="payFormTotal <= 0 || payLoading">
            {{ payLoading ? 'Saqlanmoqda...' : 'TO\'LASH' }}
          </button>
        </div>
      </div>
    </div>

    <!-- QAYTARISH (REFUND) MODALI -->
    <div v-if="showRefundModal && refundItem" class="modal-overlay" @click.self="closeRefundModal">
      <div class="refund-modal animate-pop">
        <div class="detail-header">
          <h3>Qaytarish — Savdo #{{ refundItem.id }}</h3>
          <button class="close-btn" @click="closeRefundModal">&times;</button>
        </div>

        <!-- XIZMATLAR -->
        <div v-if="refundServiceList.length > 0" class="refund-section">
          <h4 class="section-title purple">Xizmatlar</h4>
          <div v-for="(srv, idx) in refundServiceList" :key="'srv-' + idx" class="refund-check-row">
            <label class="refund-checkbox">
              <input type="checkbox" v-model="srv.selected" />
              <span class="refund-item-name">{{ srv.name }}</span>
              <span class="refund-item-price">{{ formatMoney(srv.total) }}</span>
            </label>
          </div>
        </div>

        <!-- MAHSULOTLAR -->
        <div v-if="refundProductList.length > 0" class="refund-section">
          <h4 class="section-title blue">Mahsulotlar</h4>
          <table class="detail-table">
            <thead>
              <tr>
                <th style="width:36px"></th>
                <th>Nomi</th>
                <th style="width:80px">Soni</th>
                <th>Narxi</th>
                <th>Summa</th>
                <th style="width:160px">Holati</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(prod, idx) in refundProductList" :key="'prod-' + idx">
                <td><input type="checkbox" v-model="prod.selected" /></td>
                <td>{{ prod.name }}</td>
                <td>
                  <input type="number" v-model.number="prod.refund_count" :max="prod.max_count" min="0"
                    class="refund-count-input" :disabled="!prod.selected" @input="recalcProductSumma(prod)" />
                </td>
                <td class="text-right">{{ formatMoney(prod.price) }}</td>
                <td class="text-right font-bold">{{ formatMoney(prod.refund_summa) }}</td>
                <td>
                  <div class="seg-toggle" :class="{ disabled: !prod.selected }">
                    <button type="button" :class="{ active: prod.restock }" :disabled="!prod.selected"
                      @click="prod.restock = true">Omborga</button>
                    <button type="button" :class="{ active: !prod.restock }" :disabled="!prod.selected"
                      @click="prod.restock = false">Brak</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- ALMASHTIRISH (aynan sotilgan mahsulot — ombordan yangisi) -->
        <div class="refund-section">
          <h4 class="section-title" style="color:#0891b2">Almashtirish (sotilgan mahsulot)</h4>
          <p class="exchange-hint" style="margin-bottom:8px">
            Almashtirishga faqat shu savdoda sotilgan mahsulotni tanlash mumkin — brak qaytib, o'rniga ombordan yangisi beriladi.
          </p>
          <div class="exchange-search">
            <select v-model="exchangeSelectId" class="pay-input" :disabled="exchangeSourceProducts.length === 0">
              <option :value="null" disabled>Sotilgan mahsulotni tanlang...</option>
              <option v-for="p in exchangeSourceProducts" :key="p.product_id" :value="p.product_id">
                {{ p.name }} — {{ formatMoney(p.price) }}
              </option>
            </select>
            <button type="button" class="add-exchange-btn" :disabled="exchangeSelectId == null"
              @click="addExchangeFromSold">+ Qo'shish</button>
          </div>
          <table v-if="refundExchangeList.length > 0" class="detail-table" style="margin-top:8px">
            <thead>
              <tr>
                <th>Nomi</th>
                <th style="width:80px">Soni</th>
                <th>Narxi</th>
                <th>Summa</th>
                <th style="width:36px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ex, idx) in refundExchangeList" :key="'ex-' + idx">
                <td>{{ ex.name }}</td>
                <td>
                  <input type="number" v-model.number="ex.count" min="1" class="refund-count-input"
                    @input="recalcExchangeSumma(ex)" />
                </td>
                <td class="text-right">{{ formatMoney(ex.price) }}</td>
                <td class="text-right font-bold">{{ formatMoney(ex.summa) }}</td>
                <td><button class="ex-remove" @click="removeExchange(idx)">&times;</button></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- QAYTARISH XULOSASI -->
        <div class="refund-summary">
          <div class="pay-info-row">
            <span class="info-label">Qaytarilgan qiymat:</span>
            <span class="font-bold red">{{ formatMoney(refundReturnValue) }}</span>
          </div>
          <div class="pay-info-row" v-if="refundExchangeValue > 0">
            <span class="info-label">Almashtirish qiymati:</span>
            <span class="font-bold" style="color:#0891b2">{{ formatMoney(refundExchangeValue) }}</span>
          </div>
          <div class="pay-info-row" style="border-top:2px solid #e2e8f0;padding-top:8px;margin-top:6px">
            <span class="font-bold">SOF FARQ:</span>
            <span class="font-bold" :class="refundNet >= 0 ? 'red' : 'green'">
              {{ formatMoney(refundNetAbs) }}
              <small>{{ refundNet >= 0 ? '(mijozga)' : '(mijozdan)' }}</small>
            </span>
          </div>
        </div>

        <!-- PUL-HISOB (avtomatik) -->
        <div class="pay-form">
          <h4 class="section-title" style="color:#d97706;margin-bottom:12px">Pul-hisob (avtomatik)</h4>
          <template v-if="refundNet >= 0">
            <div class="pay-info-row" v-if="refundDebtReduction > 0">
              <span class="info-label">Qarzdan ayiriladi:</span>
              <span class="font-bold">{{ formatMoney(refundDebtReduction) }}</span>
            </div>
            <div class="pay-info-row">
              <span class="info-label">Naqd qaytariladi (kassadan):</span>
              <span class="font-bold red">{{ formatMoney(refundCashBack) }}</span>
            </div>
            <p v-if="refundOutstandingDebt > 0" class="exchange-hint">
              Mijoz qarzi: {{ formatMoney(refundOutstandingDebt) }} — avval shundan ayiriladi, qolgani naqd qaytadi.
            </p>
          </template>
          <template v-else>
            <div class="pay-info-row">
              <span class="info-label">Mijozdan olinadi:</span>
              <span class="font-bold green">{{ formatMoney(refundOwed) }}</span>
            </div>
            <div class="seg-toggle" style="margin-top:8px">
              <button type="button" :class="{ active: !refundAddToDebt }" @click="refundAddToDebt = false">Naqd olish</button>
              <button type="button" :class="{ active: refundAddToDebt }" @click="refundAddToDebt = true">Qarzga yozish</button>
            </div>
          </template>
          <div class="pay-field" style="margin-top:10px">
            <label>Izoh</label>
            <input type="text" v-model="refundForm.comment" class="pay-input" placeholder="Qaytarish sababi..." />
          </div>
        </div>

        <div class="pay-actions">
          <button class="m-btn cancel" @click="closeRefundModal">BEKOR</button>
          <button class="m-btn refund-confirm" @click="submitRefund"
            :disabled="(refundReturnValue <= 0 && refundExchangeValue <= 0) || refundLoading">
            {{ refundLoading ? 'Saqlanmoqda...' : 'TASDIQLASH' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Top from '../Layout/Top.vue';

export default {
  name: 'ChiqimIndex',
  components: { Top },
  data() {
    const today = new Date();
    const y = today.getFullYear();
    const m = String(today.getMonth() + 1).padStart(2, '0');
    const d = String(today.getDate()).padStart(2, '0');
    const todayStr = `${y}-${m}-${d}`;
    const monthStart = `${y}-${m}-01`;
    return {
      loading: false,
      showDeleteModal: false,
      showDetailModal: false,
      showPayModal: false,
      showRefundModal: false,
      payLoading: false,
      refundLoading: false,
      selectedItem: null,
      detailItem: null,
      payItem: null,
      refundItem: null,
      refundProductList: [],
      refundServiceList: [],
      refundExchangeList: [],
      refundOutstandingDebt: 0,
      refundAddToDebt: false,
      exchangeSelectId: null,
      refundForm: { comment: '' },
      payForm: { comment: '' },
      paytypes: [],
      payAmounts: {},      // { [pay_type_id]: summa } — har bir to'lov turi bo'yicha summa
      payDollarRate: 1,    // dollar (id=3) to'lovini so'mga aylantirish kursi
      dollarRate: 1,       // oxirgi dollar kursi (default uchun)
      sales: [],
      masters: [],
      filterDate1: monthStart,
      filterDate2: todayStr,
      filterMasterId: null,
      skladSettings: { firmName: '', phone: '', checkWord: '', logoUrl: '' },
    };
  },
  computed: {
    totalProductSumma() {
      return this.sales.reduce((s, i) => s + Number(i.product_summa || 0), 0);
    },
    totalServiceSumma() {
      return this.sales.reduce((s, i) => s + Number(i.summa || 0) - Number(i.product_summa || 0), 0);
    },
    totalSumma() {
      return this.sales.reduce((s, i) => s + Number(i.summa || 0), 0);
    },
    totalPaid() {
      return this.sales.reduce((s, i) => s + this.getPaid(i), 0);
    },
    totalDebt() {
      return this.sales.reduce((s, i) => s + this.getDebt(i), 0);
    },
    // Jami to'lov (so'mda) — dollar (id=3) summasi kurs bo'yicha aylantiriladi
    payFormTotal() {
      const rate = Number(this.payDollarRate) || 1;
      return (this.paytypes || []).reduce((sum, pt) => {
        const amt = Number(this.payAmounts[pt.id]) || 0;
        if (amt <= 0) return sum;
        return sum + (this.isDollarType(pt.id) ? amt * rate : amt);
      }, 0);
    },
    // To'lov turlari orasida dollar (id=3) bormi — kurs maydonini ko'rsatish uchun
    hasDollarType() {
      return (this.paytypes || []).some(pt => this.isDollarType(pt.id));
    },
    // Dollar to'lovining so'm ekvivalenti (ko'rsatish uchun)
    payDollarSomEq() {
      return (Number(this.payAmounts[3]) || 0) * (Number(this.payDollarRate) || 1);
    },
    // To'lovdan keyin qoladigan qarz
    payRemaining() {
      if (!this.payItem) return 0;
      return Math.max(0, this.getDebt(this.payItem) - this.payFormTotal);
    },
    refundServiceTotal() {
      return this.refundServiceList.filter(s => s.selected).reduce((sum, s) => sum + s.total, 0);
    },
    refundProductTotal() {
      return this.refundProductList.filter(p => p.selected).reduce((sum, p) => sum + p.refund_summa, 0);
    },
    // Qaytarilgan jami qiymat (brak ham kiradi — pul baribir qaytadi)
    refundReturnValue() {
      return this.refundServiceTotal + this.refundProductTotal;
    },
    // Almashtirish uchun tanlash mumkin bo'lgan mahsulotlar — faqat shu savdoda sotilganlar
    exchangeSourceProducts() {
      return this.refundProductList.map(p => ({
        product_id: p.product_id,
        name: p.name,
        price: p.price,
      }));
    },
    // Almashtirishda beriladigan yangi mahsulotlar qiymati
    refundExchangeValue() {
      return this.refundExchangeList.reduce((sum, e) => sum + Number(e.summa || 0), 0);
    },
    // Sof farq: musbat = mijozga qaytadi, manfiy = mijozdan olinadi
    refundNet() {
      return this.refundReturnValue - this.refundExchangeValue;
    },
    refundNetAbs() {
      return Math.abs(this.refundNet);
    },
    // Avval qarzdan ayiriladi (savdoning ochiq qarzigacha)
    refundDebtReduction() {
      return this.refundNet >= 0 ? Math.min(this.refundNet, this.refundOutstandingDebt) : 0;
    },
    // Qolgani naqd qaytariladi
    refundCashBack() {
      return this.refundNet >= 0 ? this.refundNet - this.refundDebtReduction : 0;
    },
    // Almashtirish qimmatroq bo'lsa — mijoz qo'shimcha to'laydi
    refundOwed() {
      return this.refundNet < 0 ? -this.refundNet : 0;
    },
    detailSaleType() {
      return this.saleTypeOf(this.detailItem);
    },
    servicesTotal() {
      if (!this.detailItem || !this.detailItem.packages) return 0;
      return this.detailItem.packages.reduce((s, pkg) => s + this.packageLabor(pkg) + this.packageRedo(pkg), 0);
    },
  },
  mounted() {
    this.fetchSales();
    this.fetchMasters();
    this.fetchSkladSettings();
    this.fetchPaytypes();
    this.fetchDollarRate();
  },
  methods: {
    async fetchPaytypes() {
      try {
        const res = await axios.get('api/v1/pay-type');
        this.paytypes = res.data || [];
      } catch (e) { this.paytypes = []; }
    },
    async fetchDollarRate() {
      try {
        const res = await axios.get('api/v1/dollar-exchange-rate/last');
        this.dollarRate = parseFloat(res.data && res.data.rate) || 1;
      } catch (e) { /* default 1 */ }
    },
    isDollarType(id) { return parseInt(id) === 3; },
    saleTypeOf(item) {
      if (!item) return 'chakana';
      if (item.price_type) return item.price_type;
      if (item.sale_type) return item.sale_type;
      if (item.kontragent && item.kontragent.sale_type) return item.kontragent.sale_type;
      return 'chakana';
    },
    packageLabor(pkg) {
      if (!pkg) return 0;
      return this.detailSaleType === 'optom' ? Number(pkg.labor_price_optom || 0) : Number(pkg.labor_price_chakana || 0);
    },
    packageRedo(pkg) {
      if (!pkg) return 0;
      return this.detailSaleType === 'optom' ? Number(pkg.redo_price_optom || 0) : Number(pkg.redo_price_chakana || 0);
    },
    async fetchMasters() {
      try {
        const res = await axios.get('api/v1/staff');
        this.masters = res.data?.data || [];
      } catch (e) {
        this.masters = [];
      }
    },
    async fetchSales() {
      this.loading = true;
      try {
        const params = {};
        if (this.filterDate1) params.date1 = Math.floor(new Date(this.filterDate1).getTime() / 1000);
        if (this.filterDate2) params.date2 = Math.floor(new Date(this.filterDate2 + 'T23:59:59').getTime() / 1000);
        if (this.filterMasterId) params.master_user_id = this.filterMasterId;
        const res = await axios.get('api/v1/service-sale', { params });
        this.sales = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        console.error('Savdolarni yuklashda xato:', e);
        this.sales = [];
      } finally {
        this.loading = false;
      }
    },
    // Jami to'langan summa (so'mda).
    // Birinchi navbatda pay_table ishlatiladi (dollar entrylar dollar_rate bo'yicha so'mga aylantiriladi),
    // pay_table bo'sh bo'lsa — eski hardcoded ustunlar (cash_summa, plastic_summa, shot_summa, dollar_summa) ishlatiladi.
    getPaid(item) {
      if (!item) return 0;
      const rate = parseFloat(item.dollar_rate) || 1;
      const refund = Number(item.refund_money || 0)
        + Number(item.refund_money_dollar || 0) * rate;

      if (Array.isArray(item.pay_table) && item.pay_table.length > 0) {
        const gross = item.pay_table.reduce((acc, row) => {
          const s = parseFloat(row.summa) || 0;
          if (s <= 0) return acc;
          const id = parseInt(row.pay_type_id);
          return acc + (id === 3 ? s * rate : s);
        }, 0);
        return Math.max(0, gross - refund);
      }

      // Legacy fallback — eski yozuvlar uchun
      const cash = Number(item.cash_summa || 0);
      const plastic = Number(item.plastic_summa || 0);
      const shot = Number(item.shot_summa || 0);
      const dollar = Number(item.dollar_summa || 0);
      return Math.max(0, cash + plastic + shot + (dollar * rate) - refund);
    },
    getDebt(item) {
      return Math.max(0, Number(item.summa || 0) - this.getPaid(item));
    },
    getDebtClass(item) {
      return this.getDebt(item) > 0 ? 'price red' : 'price green';
    },
    // Nasiya muddatini formatlash (unix timestamp yoki ISO string)
    formatDueDate(item) {
      if (!item || !item.nasiya_date) return '';
      let d;
      if (typeof item.nasiya_date === 'number' || /^\d+$/.test(String(item.nasiya_date))) {
        d = new Date(Number(item.nasiya_date) * 1000);
      } else {
        d = new Date(item.nasiya_date);
      }
      if (isNaN(d.getTime())) return String(item.nasiya_date);
      return d.toLocaleDateString('ru-RU');
    },
    // Muddati o'tib ketganmi
    isOverdue(item) {
      if (!item || !item.nasiya_date) return false;
      let ts;
      if (typeof item.nasiya_date === 'number' || /^\d+$/.test(String(item.nasiya_date))) {
        ts = Number(item.nasiya_date) * 1000;
      } else {
        ts = new Date(item.nasiya_date).getTime();
      }
      return !isNaN(ts) && ts > 0 && ts < Date.now() && this.getDebt(item) > 0;
    },
    // To'lov turlari breakdown matni (tooltip uchun)
    paidBreakdown(item) {
      if (!item) return '';
      const rate = parseFloat(item.dollar_rate) || 1;
      const labels = { 1: 'Naqd', 2: 'Plastik', 3: 'Dollar', 4: 'Hisob' };
      const rows = [];
      if (Array.isArray(item.pay_table) && item.pay_table.length > 0) {
        for (const r of item.pay_table) {
          const s = parseFloat(r.summa) || 0;
          if (s <= 0) continue;
          const id = parseInt(r.pay_type_id);
          const name = (r.pay_type && r.pay_type.name) || labels[id] || `Tur #${id}`;
          if (id === 3) {
            rows.push(`${name}: $${this.formatMoney(s)} ≈ ${this.formatMoney(s * rate)}`);
          } else {
            rows.push(`${name}: ${this.formatMoney(s)}`);
          }
        }
      } else {
        if (item.cash_summa > 0) rows.push(`Naqd: ${this.formatMoney(item.cash_summa)}`);
        if (item.plastic_summa > 0) rows.push(`Plastik: ${this.formatMoney(item.plastic_summa)}`);
        if (item.shot_summa > 0) rows.push(`Hisob: ${this.formatMoney(item.shot_summa)}`);
        if (item.dollar_summa > 0) rows.push(`Dollar: $${this.formatMoney(item.dollar_summa)}`);
      }
      return rows.join('\n');
    },
    formatMoney(v) {
      const n = Number(v) || 0;
      return n.toLocaleString('ru-RU', { maximumFractionDigits: 2 }).replace(/,/g, ' ');
    },
    formatDate(ts) {
      if (!ts) return '-';
      return this.$formatDate(ts);
    },
    openDetailModal(item) {
      this.detailItem = item;
      this.showDetailModal = true;
    },
    closeDetailModal() {
      this.showDetailModal = false;
      this.detailItem = null;
    },
    openDeleteModal(item) {
      this.selectedItem = item;
      this.showDeleteModal = true;
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.selectedItem = null;
    },
    async fetchSkladSettings() {
      const sklad_id = localStorage.getItem('sklad_id');
      if (!sklad_id) return;
      try {
        const [skladRes, settingsRes] = await Promise.all([
          axios.get(`api/v1/sklads/id/${sklad_id}`),
          axios.post('api/v1/sklad-settings', { sklad_id, key: 'a4_printer' }),
        ]);
        const sklad = skladRes.data?.data || skladRes.data || {};
        this.skladSettings.phone = sklad.phone_number || '';
        this.skladSettings.checkWord = sklad.check_word || '';
        const printerData = settingsRes.data?.data;
        if (printerData) {
          const parsed = JSON.parse(printerData);
          this.skladSettings.firmName = parsed?.sender?.firm_name || sklad.name || '';
          if (parsed?.file_name) {
            this.skladSettings.logoUrl = axios.defaults.baseURL + 'api/v1/uploads/' + parsed.file_name;
          }
        } else {
          this.skladSettings.firmName = sklad.name || '';
        }
      } catch (e) { console.error('Sklad sozlamalari xato', e); }
    },
    printSaleReceipt(item) {
      const s = this.skladSettings;
      const clientName = item.kontragent ? item.kontragent.name : "NOMA'LUM";
      const masterName = item.master ? item.master.name : '';
      const carNumber = item.car_number || '';
      const date = this.formatDate(item.created_at);
      const saleType = this.saleTypeOf(item);
      const servicePrice = pkg => saleType === 'optom'
        ? Number(pkg.labor_price_optom || 0) + Number(pkg.redo_price_optom || 0)
        : Number(pkg.labor_price_chakana || 0) + Number(pkg.redo_price_chakana || 0);

      // Xizmatlar
      let itemsHtml = '';
      if (item.packages && item.packages.length > 0) {
        item.packages.forEach(pkg => {
          const total = servicePrice(pkg);
          itemsHtml += `<div class="item-row">
            <span class="ir-name">${pkg.name || '-'}</span>
            <span class="ir-qty">1</span>
            <span class="ir-price">${this.formatMoney(total)}</span>
            <span class="ir-total">${this.formatMoney(total)}</span>
          </div>`;
        });
      } else if (item.repair_package) {
        const total = servicePrice(item);
        itemsHtml += `<div class="item-row">
          <span class="ir-name">${item.repair_package.name}</span>
          <span class="ir-qty">1</span>
          <span class="ir-price">${this.formatMoney(total)}</span>
          <span class="ir-total">${this.formatMoney(total)}</span>
        </div>`;
      }

      // Mahsulotlar
      if (item.items && item.items.length > 0) {
        item.items.forEach(itm => {
          const name = itm.product ? (itm.product.extra_name || itm.product.name) : '-';
          itemsHtml += `<div class="item-row">
            <span class="ir-name">${name}</span>
            <span class="ir-qty">${itm.count}</span>
            <span class="ir-price">${this.formatMoney(itm.price)}</span>
            <span class="ir-total">${this.formatMoney(itm.summa)}</span>
          </div>`;
        });
      }

      const skidka = Number(item.skidka_summa || 0);
      const cashSumma = Number(item.cash_summa || 0);
      const plasticSumma = Number(item.plastic_summa || 0);
      const shotSumma = Number(item.shot_summa || 0);
      const totalSum = Number(item.summa || 0);

      const logoHtml = s.logoUrl ? `<img src="${s.logoUrl}" class="receipt-logo" alt="logo" />` : '';
      const skidkaHtml = skidka > 0 ? `<div class="calc-row"><span>Chegirma:</span><span>- ${this.formatMoney(skidka)}</span></div>` : '';
      const cashHtml = cashSumma > 0 ? `<div class="calc-row"><span>Naqd:</span><span>${this.formatMoney(cashSumma)}</span></div>` : '';
      const plasticHtml = plasticSumma > 0 ? `<div class="calc-row"><span>Plastik:</span><span>${this.formatMoney(plasticSumma)}</span></div>` : '';
      const shotHtml = shotSumma > 0 ? `<div class="calc-row"><span>Nasiya:</span><span>${this.formatMoney(shotSumma)}</span></div>` : '';
      const checkWordHtml = s.checkWord ? `<div class="check-word">${s.checkWord}</div>` : '';
      const masterHtml = masterName ? `<div class="info-row"><span class="info-label">Usta:</span><span class="info-value">${masterName}</span></div>` : '';
      const carHtml = carNumber ? `<div class="info-row"><span class="info-label">Mashina:</span><span class="info-value">${carNumber}</span></div>` : '';

      const printWindow = window.open('', '_blank', 'width=320,height=600');
      printWindow.document.write(`<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>Chek #${item.id}</title>
<style>
  @page { size: 80mm auto; margin: 0; }
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body {
    width: 80mm; font-family: 'Arial', 'Helvetica', sans-serif;
    font-size: 12px; font-weight: 700; color: #000; padding: 3mm;
    -webkit-font-smoothing: antialiased;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .receipt-logo { display: block; max-width: 60mm; max-height: 22mm; margin: 0 auto 2mm; object-fit: contain; }
  .receipt-header { text-align: center; margin-bottom: 2mm; }
  .firm-name { font-size: 16px; font-weight: 900; letter-spacing: 0.5px; text-transform: uppercase; }
  .firm-phone { font-size: 11px; margin-top: 1mm; }
  .receipt-date { font-size: 11px; color: #000; margin-top: 1mm; }
  .receipt-divider { border-top: 3px dashed #000; margin: 2mm 0; }
  .receipt-divider-solid { border-top: 3px solid #000; margin: 1mm 0; }
  .receipt-info { margin: 1mm 0; }
  .info-row { display: flex; justify-content: space-between; font-size: 12px; line-height: 1.5; }
  .info-label { color: #000; }
  .info-value { font-weight: 700; text-align: right; max-width: 55%; word-break: break-word; }
  .item-header { display: flex; font-size: 10px; font-weight: 700; padding: 0.5mm 0; }
  .ih-name { flex: 1; } .ih-qty { width: 8mm; text-align: center; }
  .ih-price { width: 14mm; text-align: right; } .ih-total { width: 16mm; text-align: right; }
  .item-row { display: flex; align-items: flex-start; font-size: 11px; line-height: 1.45; border-bottom: 3px solid #000; padding: 1.5mm 0; }
  .ir-name { flex: 1; min-width: 0; padding-right: 2mm; white-space: normal; word-break: break-word; overflow-wrap: anywhere; }
  .ir-qty { width: 8mm; text-align: center; }
  .ir-price { width: 14mm; text-align: right; font-size: 10px; }
  .ir-total { width: 16mm; text-align: right; font-weight: 700; }
  .calc-section { margin: 2mm 0; }
  .calc-row { display: flex; justify-content: space-between; font-size: 12px; line-height: 1.6; }
  .calc-total { font-size: 15px; font-weight: 900; border-top: 2px solid #000; border-bottom: 2px solid #000; padding: 1mm 0; margin: 1mm 0; }
  .receipt-footer { text-align: center; margin-top: 2mm; padding-bottom: 3mm; }
  .check-word { font-weight: 800; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px; }
  .thank-you { font-size: 11px; color: #000; margin-top: 1mm; }
</style>
</head>
<body>
  <div class="receipt-header">
    ${logoHtml}
    <div class="firm-name">${s.firmName}</div>
    ${s.phone ? '<div class="firm-phone">Tel: ' + s.phone + '</div>' : ''}
    <div class="receipt-date">${date}</div>
  </div>
  <div class="receipt-divider"></div>
  <div class="receipt-info">
    <div class="info-row"><span class="info-label">Mijoz:</span><span class="info-value">${clientName}</span></div>
    ${masterHtml}
    ${carHtml}
  </div>
  <div class="receipt-divider"></div>
  <div class="item-header">
    <span class="ih-name">Nomi</span>
    <span class="ih-qty">Soni</span>
    <span class="ih-price">Narxi</span>
    <span class="ih-total">Summa</span>
  </div>
  <div class="receipt-divider-solid"></div>
  ${itemsHtml}
  <div class="receipt-divider"></div>
  <div class="calc-section">
    ${skidkaHtml}
    <div class="calc-row calc-total"><span>JAMI:</span><span>${this.formatMoney(totalSum)}</span></div>
    ${cashHtml}
    ${plasticHtml}
    ${shotHtml}
  </div>
  <div class="receipt-divider"></div>
  <div class="receipt-footer">
    ${checkWordHtml}
    <div class="thank-you">Xaridingiz uchun rahmat!</div>
  </div>
</body>
</html>`);
      printWindow.document.close();
      printWindow.focus();
      setTimeout(() => { printWindow.print(); printWindow.close(); }, 400);
    },
    async deleteItem() {
      try {
        await axios.delete(`api/v1/service-sale/id/${this.selectedItem.id}`);
        this.sales = this.sales.filter(s => s.id !== this.selectedItem.id);
        this.closeDeleteModal();
      } catch (e) {
        alert("O'chirishda xatolik yuz berdi");
      }
    },
    openPayModal(item) {
      this.payItem = item;
      this.payForm = { comment: `Savdo #${item.id} uchun to'lov` };
      // Dollar kursi: savdo kursidan, bo'lmasa oxirgi kursdan
      this.payDollarRate = Number(item.dollar_rate) || this.dollarRate || 1;
      // Barcha to'lov turlari uchun summa maydonini 0 bilan tayyorlaymiz (Vue 2 reaktivligi)
      // Avtomatik to'ldirish yo'q — kassir o'zi kiritadi
      const amounts = {};
      (this.paytypes || []).forEach(pt => { amounts[pt.id] = 0; });
      this.payAmounts = amounts;
      this.showPayModal = true;
    },
    closePayModal() {
      this.showPayModal = false;
      this.payItem = null;
      this.payAmounts = {};
    },
    openRefundModal(item) {
      this.refundItem = item;
      // Savdo qaysi turda (chakana/optom) bo'lgan bo'lsa, faqat o'sha turdagi narx
      // qaytariladi — ikkalasini birga qo'shish xizmat summasini noto'g'ri oshirib yuborardi.
      const saleType = this.saleTypeOf(item);
      // Xizmatlar ro'yxatini tayyorlash
      this.refundServiceList = [];
      if (item.packages && item.packages.length > 0) {
        this.refundServiceList = item.packages.map(pkg => {
          const labor = saleType === 'optom' ? Number(pkg.labor_price_optom || 0) : Number(pkg.labor_price_chakana || 0);
          const redo = saleType === 'optom' ? Number(pkg.redo_price_optom || 0) : Number(pkg.redo_price_chakana || 0);
          return {
            repair_package_id: pkg.repair_package_id,
            name: pkg.name || '-',
            labor_price_chakana: saleType === 'optom' ? 0 : labor,
            redo_price_chakana: saleType === 'optom' ? 0 : redo,
            labor_price_optom: saleType === 'optom' ? labor : 0,
            redo_price_optom: saleType === 'optom' ? redo : 0,
            total: labor + redo,
            selected: false,
          };
        });
      } else if (item.repair_package) {
        const labor = saleType === 'optom' ? Number(item.labor_price_optom || 0) : Number(item.labor_price_chakana || 0);
        const redo = saleType === 'optom' ? Number(item.redo_price_optom || 0) : Number(item.redo_price_chakana || 0);
        const total = labor + redo;
        if (total > 0) {
          this.refundServiceList = [{
            repair_package_id: item.repair_package_id || (item.repair_package && item.repair_package.id),
            name: item.repair_package.name,
            labor_price_chakana: saleType === 'optom' ? 0 : labor,
            redo_price_chakana: saleType === 'optom' ? 0 : redo,
            labor_price_optom: saleType === 'optom' ? labor : 0,
            redo_price_optom: saleType === 'optom' ? redo : 0,
            total,
            selected: false,
          }];
        }
      }
      // Mahsulotlar ro'yxatini tayyorlash
      this.refundProductList = [];
      if (item.items && item.items.length > 0) {
        this.refundProductList = item.items.map(itm => ({
          product_id: itm.product_id,
          name: itm.product ? (itm.product.extra_name || itm.product.name) : '-',
          max_count: Number(itm.count),
          refund_count: Number(itm.count),
          price: Number(itm.price),
          refund_summa: Number(itm.summa),
          selected: false,
          restock: true, // true=omborga qaytsin, false=brak
        }));
      }
      // Almashtirish va avtomatik pul-hisob holatini tiklash
      this.refundExchangeList = [];
      this.exchangeSelectId = null;
      this.refundAddToDebt = false;
      this.refundOutstandingDebt = this.getDebt(item); // server qayta hisoblaydi, bu faqat ko'rsatma
      this.refundForm = { comment: '' };
      this.showRefundModal = true;
    },
    closeRefundModal() {
      this.showRefundModal = false;
      this.refundItem = null;
      this.refundProductList = [];
      this.refundServiceList = [];
      this.refundExchangeList = [];
      this.exchangeSelectId = null;
    },
    recalcProductSumma(prod) {
      if (prod.refund_count > prod.max_count) prod.refund_count = prod.max_count;
      if (prod.refund_count < 0) prod.refund_count = 0;
      prod.refund_summa = prod.refund_count * prod.price;
    },
    // Almashtirish uchun faqat shu savdoda sotilgan mahsulotni qo'shish.
    // Narx — aynan sotilgan narx (brak qaytib o'rniga ombordan yangisi, farq nol bo'ladi).
    addExchangeFromSold() {
      const pid = this.exchangeSelectId;
      if (pid == null) return;
      const sold = this.refundProductList.find(p => p.product_id === pid);
      if (!sold) return;
      const existing = this.refundExchangeList.find(e => e.product_id === pid);
      if (existing) {
        existing.count += 1;
        existing.summa = existing.count * existing.price;
      } else {
        this.refundExchangeList.push({
          product_id: sold.product_id,
          name: sold.name,
          price: sold.price,
          count: 1,
          summa: sold.price,
        });
      }
      this.exchangeSelectId = null;
    },
    recalcExchangeSumma(ex) {
      if (!ex.count || ex.count < 1) ex.count = 1;
      ex.summa = ex.count * ex.price;
    },
    removeExchange(idx) {
      this.refundExchangeList.splice(idx, 1);
    },
    async submitRefund() {
      if ((this.refundReturnValue <= 0 && this.refundExchangeValue <= 0) || !this.refundItem) return;
      this.refundLoading = true;
      try {
        const refund_items = this.refundProductList
          .filter(p => p.selected && p.refund_count > 0)
          .map(p => ({
            product_id: p.product_id, count: p.refund_count, price: p.price,
            summa: p.refund_summa, restock: p.restock !== false,
          }));
        const refund_services = this.refundServiceList
          .filter(s => s.selected)
          .map(s => ({
            repair_package_id: s.repair_package_id,
            labor_price_chakana: s.labor_price_chakana,
            redo_price_chakana: s.redo_price_chakana,
            labor_price_optom: s.labor_price_optom,
            redo_price_optom: s.redo_price_optom,
          }));
        const exchange_items = this.refundExchangeList
          .filter(e => e.count > 0)
          .map(e => ({ product_id: e.product_id, count: e.count, price: e.price, summa: e.summa }));
        await axios.post(`api/v1/service-sale/id/${this.refundItem.id}/refund`, {
          refund_items,
          refund_services,
          exchange_items,
          settlement_mode: 'auto',
          add_to_debt: this.refundAddToDebt,
          comment: this.refundForm.comment || '',
        });
        this.closeRefundModal();
        this.fetchSales();
      } catch (e) {
        console.error('Qaytarish xatosi:', e);
        alert("Qaytarishda xatolik yuz berdi");
      } finally {
        this.refundLoading = false;
      }
    },
    async submitPayment() {
      if (this.payFormTotal <= 0 || !this.payItem) return;
      this.payLoading = true;
      try {
        // Har bir to'lov turi bo'yicha summa (dollar $ da, qolganlari so'mda)
        const pay_table = (this.paytypes || [])
          .map(pt => ({ pay_type_id: parseInt(pt.id), summa: Number(this.payAmounts[pt.id]) || 0 }))
          .filter(r => r.summa > 0);
        await axios.patch(`api/v1/service-sale/id/${this.payItem.id}/pay`, {
          pay_table,
          dollar_rate: Number(this.payDollarRate) || 1,
          comment: this.payForm.comment || '',
        });

        this.closePayModal();
        this.fetchSales();
      } catch (e) {
        console.error('To\'lov xatosi:', e);
        alert("To'lovda xatolik yuz berdi");
      } finally {
        this.payLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: calc(100vh - 56px);
  height: calc(100dvh - 56px);
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1600px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 14px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 24px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
}

.date-input {
  height: 40px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 0 12px;
  font-weight: 600;
  color: #475569;
  outline: none;
  background: white;
}

.master-select {
  height: 40px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 0 12px;
  font-weight: 600;
  color: #475569;
  outline: none;
  background: white;
  min-width: 160px;
}

.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 40px;
  padding: 0 18px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
}

.table-card {
  background: white;
  border-radius: 20px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 14px 10px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
}

.custom-table td {
  padding: 11px 10px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
}

.total-row td {
  padding: 12px 10px;
  background: #f8fafc;
  border-top: 2px solid #e2e8f0;
  font-size: 14px;
}

.id-badge {
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 7px;
  font-weight: 700;
  color: #64748b;
  font-size: 12px;
}

.price { font-weight: 700; }
.blue  { color: #2563eb; }
.green { color: #10b981; }
.red   { color: #e11d48; }

.tag {
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
}

.blue-tag { background: #eff6ff; color: #2563eb; }

/* To'langan summa yonidagi info ikon */
.paid-info-ico {
  font-size: 11px;
  color: #94a3b8;
  margin-left: 4px;
  vertical-align: baseline;
  cursor: help;
}

/* Muddat badge */
.due-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #fef3c7;
  color: #b45309;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}
.due-badge.overdue {
  background: #fee2e2;
  color: #b91c1c;
  animation: due-pulse 1.6s ease-in-out infinite;
}
@keyframes due-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.25); }
  50% { box-shadow: 0 0 0 4px rgba(220, 38, 38, 0); }
}

.actions { display: flex; gap: 6px; justify-content: center; }

.icon-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.edit  { background: #eff6ff; color: #2563eb; }
.print { background: #f0fdf4; color: #10b981; }
.del   { background: #fff1f2; color: #e11d48; }
.pay   { background: #fef3c7; color: #d97706; }

.clickable-row { cursor: pointer; transition: background 0.15s; }
.clickable-row:hover { background: #f8fafc; }

.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(15,23,42,0.3);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-box {
  background: white;
  padding: 35px;
  border-radius: 28px;
  width: 420px;
  text-align: center;
  box-shadow: 0 20px 50px rgba(0,0,0,0.1);
}

.warning-icon {
  width: 60px; height: 60px;
  background: #fee2e2; color: #ef4444;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 30px; font-weight: bold;
  margin: 0 auto 20px;
}

.modal-btns { display: flex; gap: 12px; margin-top: 25px; }

.m-btn {
  flex: 1;
  padding: 13px;
  border-radius: 14px;
  border: none;
  font-weight: 700;
  cursor: pointer;
}

.cancel  { background: #f1f5f9; color: #64748b; }
.confirm { background: #e11d48; color: white; }

.animate-pop {
  animation: pop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes pop {
  0%   { transform: scale(0.9); opacity: 0; }
  100% { transform: scale(1);   opacity: 1; }
}

/* DETAIL MODAL */
.detail-modal {
  background: white;
  padding: 0;
  border-radius: 24px;
  width: 620px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 20px 50px rgba(0,0,0,0.12);
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid #f1f5f9;
}

.detail-header h3 {
  margin: 0;
  font-size: 18px;
  color: #1e293b;
}

.close-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  background: #f1f5f9;
  font-size: 22px;
  cursor: pointer;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover { background: #e2e8f0; }

.detail-info {
  padding: 16px 25px;
  background: #f8fafc;
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.info-row {
  font-size: 13px;
  color: #475569;
}

.info-label {
  color: #94a3b8;
  margin-right: 4px;
}

.detail-section {
  padding: 16px 25px 8px;
}

.section-title {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0 0 10px;
}

.section-title.purple { color: #a142f4; }
.section-title.blue { color: #2563eb; }

.sale-type-chip {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.5px;
  vertical-align: middle;
  text-transform: uppercase;
}
.sale-type-chip.chakana { background: #dbeafe; color: #2563eb; }
.sale-type-chip.optom { background: #fef3c7; color: #d97706; }

.detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.detail-table th {
  padding: 8px 10px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: left;
  border-bottom: 1px solid #f1f5f9;
}

.detail-table td {
  padding: 8px 10px;
  border-bottom: 1px solid #f8fafc;
  color: #334155;
}

.detail-table .total-row td {
  border-top: 2px solid #e2e8f0;
  padding-top: 10px;
}

.purple { color: #a142f4; }

.detail-footer {
  padding: 16px 25px 20px;
  border-top: 1px solid #f1f5f9;
  margin-top: 8px;
}

.footer-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 14px;
  color: #475569;
}

.footer-row.total {
  padding-top: 10px;
  margin-top: 6px;
  border-top: 2px solid #e2e8f0;
  font-size: 16px;
}

/* To'lov breakdown bloki */
.pay-breakdown {
  margin-top: 10px;
  padding: 10px 12px;
  background: #f8fafc;
  border-radius: 12px;
  border-left: 3px solid #10b981;
}
.pay-breakdown-title {
  font-size: 11px;
  font-weight: 800;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.footer-row.pay-line {
  padding: 3px 0;
  font-size: 13px;
}
.footer-row.pay-line small {
  color: #94a3b8;
  font-weight: 500;
  margin-left: 4px;
}

.empty-detail {
  padding: 30px;
  text-align: center;
  color: #94a3b8;
}

/* TO'LOV MODALI */
.pay-modal {
  background: white;
  border-radius: 24px;
  width: 480px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.12);
}

.pay-info {
  padding: 16px 25px;
  background: #f8fafc;
}

.pay-info-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 14px;
}

.pay-form {
  padding: 20px 25px;
}

.pay-field {
  margin-bottom: 12px;
}

/* Barcha to'lov turlari to'r ko'rinishida */
.method-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 14px;
  margin-bottom: 12px;
}
.method-grid .pay-field {
  margin-bottom: 0;
}
.conv-hint {
  display: block;
  margin-top: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #0891b2;
}

.pay-field label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.pay-input {
  width: 100%;
  height: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 600;
  outline: none;
}

.pay-input:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161,66,244,0.1);
}

.pay-total-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 0 0;
  margin-top: 8px;
  border-top: 2px solid #e2e8f0;
  font-size: 16px;
}

.pay-actions {
  display: flex;
  gap: 12px;
  padding: 0 25px 20px;
}

.pay-confirm {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
}

.pay-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* REFUND MODAL */
.refund-btn { background: #fef3c7; color: #d97706; }

.refund-modal {
  background: white;
  border-radius: 24px;
  width: 600px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 20px 50px rgba(0,0,0,0.12);
}

.refund-section {
  padding: 16px 25px 8px;
}

.refund-check-row {
  padding: 6px 0;
  border-bottom: 1px solid #f8fafc;
}

.refund-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 14px;
}

.refund-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #a142f4;
  cursor: pointer;
}

.refund-item-name {
  flex: 1;
  color: #334155;
  font-weight: 600;
}

.refund-item-price {
  font-weight: 700;
  color: #a142f4;
}

.refund-count-input {
  width: 64px;
  height: 30px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0 6px;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  outline: none;
}

.refund-count-input:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 2px rgba(161,66,244,0.1);
}

.refund-count-input:disabled {
  background: #f1f5f9;
  color: #94a3b8;
}

.refund-summary {
  padding: 12px 25px;
  background: #f8fafc;
}

.refund-confirm {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  color: white !important;
}

.refund-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Omborga / Brak segment tugmasi */
.seg-toggle {
  display: inline-flex;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}
.seg-toggle button {
  border: none;
  background: #f8fafc;
  color: #64748b;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.15s;
}
.seg-toggle button + button {
  border-left: 1px solid #e2e8f0;
}
.seg-toggle button.active {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: #fff;
}
.seg-toggle button.active:nth-child(2) {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}
.seg-toggle.disabled {
  opacity: 0.5;
}
.seg-toggle button:disabled {
  cursor: not-allowed;
}

/* Almashtirish qidiruv */
.exchange-search {
  position: relative;
  display: flex;
  gap: 8px;
  align-items: center;
}
.exchange-search .pay-input {
  flex: 1;
}
.add-exchange-btn {
  border: none;
  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  padding: 0 16px;
  height: 38px;
  border-radius: 10px;
  cursor: pointer;
  white-space: nowrap;
}
.add-exchange-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.exchange-dropdown {
  list-style: none;
  margin: 4px 0 0;
  padding: 4px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  max-height: 220px;
  overflow-y: auto;
  position: absolute;
  z-index: 30;
  width: 100%;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
}
.exchange-dropdown li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
}
.exchange-dropdown li:hover {
  background: #ecfeff;
}
.exchange-dropdown .ex-price {
  font-size: 12px;
  color: #0891b2;
  font-weight: 700;
  white-space: nowrap;
}
.ex-remove {
  border: none;
  background: #fee2e2;
  color: #dc2626;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}
.ex-remove:hover {
  background: #fecaca;
}
.exchange-hint {
  margin: 8px 0 0;
  font-size: 12px;
  color: #64748b;
}
</style>
